// extracted by mini-css-extract-plugin
export default {"image":"yY-z","loaded":"zY-z","placeholder":"AY-z"};